import { TTerminalCommand } from "@/types";

import { typeArg } from "../args";
import { stringArg } from "../args/string.arg";

export const newCommand: TTerminalCommand = {
	command: "new",
	description: "Creates a new item",
	execute: (_args) => {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve();
			}, 1000);
		});
	},
	args: [
		typeArg({ description: "The type of item to create", command: "new" }),
		stringArg({
			name: "name",
			description: "The name of the item",
			required: true,
		}),
	],
};
